import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import "./EditCollectionFolders.scss";

import { ReactComponent as FolderImg } from "static/icons/folder-templates.svg";
import { ReactComponent as OptionImg } from "static/icons/options.svg";
import UniversalButton from "../uiComponents/UniversalButton";
import { ReactComponent as PlusСircleIcon } from "../../static/icons/plus-circle.svg";
import ModalComponent from "../modals/ModalComponent";
import CreateFolder from "../template/CreateFolder";
import { createCollectionFolder, collectionFolderRename, collectionFolderDelete } from "../../store/actions/collections";
import { useDispatch } from "react-redux";
import OptionMenu from "../template/OptionMenu";
import ProofModal from "../modals/ProofModal";
import { showToast } from "../../utils/helpers";

const EditCollectionFolders = ({ closeEditFolderModal, list, setNewListTitle, deleteTitle }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [isCreateFolderModal, setCreateFolderModal] = useState(false);
  const [optionMenuFolder, setOptionMenuFolder] = useState(null);
  const [isEditFolder, setEditFolder] = useState(null);
  const [proofModal, setProofModal] = useState(false);

  const addFolder = async (folderName) => {
    try {
      await dispatch(createCollectionFolder(folderName));
      showToast(true, t('selection_sets_folder_created'));
    } catch (error) {
      showToast(false, error);
    }
  }

  const openCreateFolderModal = () => {
    setCreateFolderModal(true);
  };

  const closeCreateFolderModal = () => {
    setCreateFolderModal(false);
  };

  const openOptionMenuFolder = (event, name) => {
    event.stopPropagation();

    if (optionMenuFolder && name === optionMenuFolder?.folderName) {
      closeOptionMenuFolder();
    } else {

      const clientX = event.clientX + 19;
      const clientY = event.clientY - 20;

      setOptionMenuFolder({ clientX, clientY, templateName: null, folderName: name });
    }
  }

  const closeOptionMenuFolder = () => {
    setOptionMenuFolder(null);
  }

  const openEditFolder = () => {
    closeOptionMenuFolder();
    setEditFolder(optionMenuFolder?.folderName);
  }

  const closeEditFolder = () => {
    setEditFolder(null);
  };

  const editFolder = async (originalNameFolder, newNameFolder) => {
    try {
      await dispatch(collectionFolderRename({ originalNameFolder, newNameFolder }));
      showToast(true, t('selection_sets_folder_renamed'));
    } catch (error) {
      showToast(false, error);
    }
    setNewListTitle(originalNameFolder, newNameFolder);
  }

  const isScroll = () => {
    closeOptionMenuFolder();
  };

  const closeProofModal = () => {
    setProofModal(false);
  };

  const deleteItem = async () => {
    const folderName = proofModal;

    try {
      await dispatch(collectionFolderDelete(folderName));
      deleteTitle(folderName);
      closeProofModal();
      showToast(true, t('selection_sets_folder_deleted'));
    } catch (error) {
      showToast(false, error);
    }
  }

  const openProofModal = () => {
    closeOptionMenuFolder();
    setProofModal(optionMenuFolder?.folderName);
  }

  return (
    <div className="edit-collection-folders">
      <div className="edit-collection-folders__header">{t('selection_sets_folders')}</div>
      <div className="edit-collection-folders__list" onScroll={isScroll}>
        {
          list.map((folder) => {
            return (
              <div className="edit-collection-folders__folder">
                <div className="edit-collection-folders__folder-left">
                  <FolderImg />
                  <div className="edit-collection-folders__folder-title">{folder}</div>
                </div>
                <OptionImg onClick={(events) => { openOptionMenuFolder(events, folder) }} />
              </div>
            )
          })
        }
      </div>
      <div className="edit-collection-folders__btns">
        <div className="edit-collection-folders__btns__create">
          <UniversalButton
            label={t('create_folder')}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="white"
            isFullWidth
            leftIcon={<PlusСircleIcon />}
            premium={false}
            onClick={openCreateFolderModal}
          />
        </div>

        <div className="edit-collection-folders__btns_btn">
          <UniversalButton
            type="button"
            label={t('close')}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={closeEditFolderModal}
          />
        </div>
      </div>
      <div className={`option-menu-wrapper ${optionMenuFolder ? "open" : ""}`} style={{ top: optionMenuFolder?.clientY, left: optionMenuFolder?.clientX }}>
        {
          optionMenuFolder &&
          <OptionMenu 
            closeOptionMenu={closeOptionMenuFolder}
            edit={openEditFolder}
            openProofModal={openProofModal} 
            isEditButtonVisible={optionMenuFolder?.folderName !== "My selection sets"}
          />
        }
      </div>
      
      <ModalComponent
        onCloseModal={closeEditFolder}
        isVisible={isEditFolder}
      >
        <CreateFolder closeCreateFolderModal={closeEditFolder} addOrEditFolder={editFolder} type={"edit"} currentFolderName={isEditFolder} />
      </ModalComponent>

      <ModalComponent
        onCloseModal={closeCreateFolderModal}
        isVisible={isCreateFolderModal}
      >
        <CreateFolder closeCreateFolderModal={closeCreateFolderModal} addOrEditFolder={addFolder} type={"create"} />
      </ModalComponent>

      <ModalComponent
        onCloseModal={closeProofModal}
        isVisible={proofModal}
      >
        <ProofModal onCloseModal={closeProofModal} proofCallback={deleteItem} cancelButtonText={t('cancel')} proofButtonText={t('yes_delete')}>
        <div>{t('you_want_delete')} <b>“{proofModal}”</b> {t('folder')}?</div>
        </ProofModal>
      </ModalComponent>
    </div>
  );
};

export default EditCollectionFolders;